module.exports = __webpack_public_path__ + "static/scale-model-of-clearwater-marine-aquarium-in-clearwater-florida-bc4ab8a7b9058dd4496ac977548e4755.png";